import { render, staticRenderFns } from "./takeOcr.vue?vue&type=template&id=4d769d3c&scoped=true&"
import script from "./takeOcr.vue?vue&type=script&lang=js&"
export * from "./takeOcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d769d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d769d3c')) {
      api.createRecord('4d769d3c', component.options)
    } else {
      api.reload('4d769d3c', component.options)
    }
    module.hot.accept("./takeOcr.vue?vue&type=template&id=4d769d3c&scoped=true&", function () {
      api.rerender('4d769d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/balanceCompany/company/takeOcr.vue"
export default component.exports